define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var WidgetsManagerViewController = require('web-agent-framework/WidgetsManagerViewController');
    var TabsManagerViewController = require('web-agent-viewControllers/TabsManagerViewController');

    var BaseTableWidgetsManager = WidgetsManagerViewController.extend({
        ControllerName: 'BaseTableWidgetsManager',
        applicationType: 'BaseTableWidgetsManager',
        WIDGETS_PADDING: 0,
        DEFAULT_MIN_WIDTH: 360,
        DEFAULT_MAX_WIDTH: 360,

        LPViewMap: {
            closeButton: ".lpview_close_widget_icon"
        },

        initialize: function (constructorData) {
            this.textsPrefix = constructorData.textsPrefix;
            this.tableName = constructorData.tableName;
            this.itemIdTag = constructorData.itemIdTag;
            this.tableRootModelPath = constructorData.tableRootModelPath;

            if (constructorData.widgetsData) {
                this.initializeWidgets(constructorData.widgetsData);
            }
        },

        events: function () {
            this.bindViewEvent({selector: this.LPViewMap.closeButton, DOMEvent: "click", callback: this.closeWidgetsArea});
            this.viewEventsHandler.bindEvent({appName : this.tableName, UIEvent : this.eventType.TABLE_WIDGETS_OPENED, callback: this.onSelectedItemChanged});
            this.viewEventsHandler.bindEvent({appName : this.tableName, UIEvent : this.eventType.TABLE_FILTER_OPENED, callback: this.closeWidgetsArea});
            // TODO think on adding here some bind that will inform us we need to close the widgets, this is temp solution for VF only
            this.viewEventsHandler.bindEvent({appName : TabsManagerViewController.applicationType, UIEvent : this.eventType.VISITOR_FOCUSED, callback: this.closeWidgetsArea});
        },

        render: function () {
        }
    });

    BaseTableWidgetsManager.prototype.initializeWidgets = function (widgetsData) {
        for (var i = 0; i < widgetsData.length; i++) {
            this.initializeWidget(widgetsData[i]);
        }
    };

    BaseTableWidgetsManager.prototype.initializeWidget = function (widgetData) {
        if (widgetData && widgetData.widgetType && widgetData.widgetData) {
            var widgetType = widgetData.widgetType;
            var widgetConstructorData = widgetData.widgetData;
            var widgetIcon = widgetConstructorData.widgetIcon || widgetType.prototype.widgetIcon;
            if (widgetIcon) {
                this.createPlaceholder(widgetType.applicationType, widgetIcon);
                this.addGlobalWidgetData(widgetConstructorData);
                if (!this[widgetType.applicationType]) {
                    this[widgetType.applicationType] = new widgetType(widgetConstructorData);
                }
            }
        }
    };

    BaseTableWidgetsManager.prototype.addGlobalWidgetData = function (widgetData) {
        if (widgetData) {
            widgetData.widgetsManager = this;
            widgetData.modelController = this.modelController;
            widgetData.singleton = true;
            widgetData.tableName = this.tableName;
            widgetData.tableRootModelPath = this.tableRootModelPath;
        }
    };

    BaseTableWidgetsManager.prototype.getNumberOfActiveWidgets = function (widgetsArray, width) {
        WidgetsManagerViewController.prototype.getNumberOfActiveWidgets.call(this, widgetsArray, width);
        return 1;
        // we comment out this line because for now we want to show only one widget

//    var bodyWidth = this.getComputedStyle(this.view.parentNode, "width", 10);
//    if (bodyWidth < 1280) {    // in this resolution  - show only 1 widget
//        return 1;
//    } else {
//        return widgetsArray.length;
//    }
    };

    BaseTableWidgetsManager.prototype.closeWidgetsArea = function () {
        if (this.visible) {
            this.lpHide();
            var activeName = null;
            LE.context.set("LEWebAgent.activity", activeName);
            this.selectedItemId = null;
            this.viewEventsHandler.fireEvent({appName : this.tableName, UIEvent : this.eventType.TABLE_WIDGETS_CLOSED});
        }
    };

    BaseTableWidgetsManager.prototype.updateSelectedItemData = function (itemData, delayed) {
        clearSelectionDelayTimeout(this);
        if (delayed !== false) {
            this.updateTimeout = setTimeout(createUpdateFunction(this, itemData), 300);
        } else {
            updateItemWidgets(this, itemData);
        }

        function createUpdateFunction(context, itemData) {
            return function () {
                // Making sure that when the delay is over - the widget manager is visible and the id has changed.
                // If the widget manager is closed, or the id hasn't changed - we don't need to update the widgets
                // This is the case after the delay (selection changed). We shouldn't check this when there's a click.
                var selectedItemId = lpUtils.getPropertyValueByPath(itemData, context.itemIdTag);
                if (context.visible && itemData && context && selectedItemId && (!context.selectedItemId || context.selectedItemId !== selectedItemId)) {
                    updateItemWidgets(context, itemData);
                }
            };
        }

        function updateItemWidgets(context, itemData) {
            if (!context.selectedItemId) {
                var activeName = 'tableWidgetContainer';
                LE.context.set("LEWebAgent.activity", activeName);
            }
            // context.selectedItemId = itemData[context.itemIdTag];
            context.selectedItemId = lpUtils.getPropertyValueByPath(itemData, context.itemIdTag);
            context.viewEventsHandler.fireEvent({appName : context.tableName, UIEvent : context.eventType.TABLE_WIDGETS_OPENED, eventData: itemData});

        }

        function clearSelectionDelayTimeout(context) {
            if (context.updateTimeout) {
                clearTimeout(context.updateTimeout);
                context.updateTimeout = null;
            }
        }
    };

    BaseTableWidgetsManager.prototype.onSelectedItemChanged = function (data) {
        var itemData = data.newValue.eventData;
        if (itemData && lpUtils.getPropertyValueByPath(itemData, this.itemIdTag)) {
            this.selectedItemId = lpUtils.getPropertyValueByPath(itemData, this.itemIdTag);
            this.selectedWidget = 0;
            this.startWidget = 0;
            this.delayedLayoutWidgets(true);
        }
    };

    return BaseTableWidgetsManager;

});
